import { getCostSagaAction } from "../redux/sagaActions";

const getCost = ({ dispatch, type, times, duration, coach, time_constraint, request_type, user }) => {
    // Запрашиваем цену для абонемента
    if (request_type === 'add_subscription' || request_type === 'update_subscription') {
        // Проверка наличия необходимых данных
        if (type && times && duration) {
            dispatch(getCostSagaAction({
                type,
                times,
                duration,
                coach,
                time_constraint,
                request_type,
                user
            }));
        }
    }
    // Запрашиваем цену для разового посещения
    else if (request_type === 'one_time') {
        // Проверка наличия необходимых данных
        if (type) {
            dispatch(getCostSagaAction({
                type,
                coach,
                request_type
            }));
        }
    }
};

export default getCost;